export default {
  methods: {
    shouldShowAdditionalField(fieldConfig) {
      if (fieldConfig.conditionalOn) {
        // This field should only be shown if another field is true.
        // That 'upstream' field is likely a conditional_boolean.
        const upstreamFieldName = fieldConfig.conditionalOn

        // The `upstreamFieldName` is for an additional field.
        // Its name is not camelCased (neither when passed in in field config `conditionalOn`,
        // nor in the Vue(x) code implementing this mixin.
        return !!(this.additionalFieldValue(upstreamFieldName))
      } else if (fieldConfig.conditionalOnValue) {
        // This field should only be shown if another field has a specific value
        const upstreamFieldName = fieldConfig.conditionalOnValue.field
        const expectedValue = fieldConfig.conditionalOnValue.value

        return this.additionalFieldValue(upstreamFieldName) === expectedValue
      } else {
        return true
      }
    }
  }
}
